import { render, staticRenderFns } from "./PanelOutbound.vue?vue&type=template&id=76f2ae52"
import script from "./PanelOutbound.vue?vue&type=script&lang=js"
export * from "./PanelOutbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports